<div class="auth-fullpage">
  <div id="logo-container" [@fadeInGlideUp]="authService.animationDuration">
    <app-logo width="217px" height="48px" class="svg-bold"></app-logo>
  </div>

  <div id="component-container" class="position-relative" [@fadeInGlideDown]="authService.animationDuration">
    <c-card id="component-view-port" class="w-30 p-3 position-absolute top-50 start-50 translate-middle-x">
      <c-card-body>
        @if (!showConfirmation()) {
          <form [formGroup]="form" (ngSubmit)="onSubmit()" fade>
            <app-alert-message [parentComponent]="this"></app-alert-message>
            <app-control-input-user formControlName="email" [placeholder]="'AUTH_LOGIN_PLACEHOLDER_USERNAME'">
            </app-control-input-user>
            <app-control-button-submit
              [parentComponent]="this"
              [buttonText]="'AUTH_LOGIN_BUTTON_FORGOT_PASSWORD_REQUEST'"
              [disabled]="authService.submitButtonIsDisabled(this)"
              [icon]="icons.paperPlane"
            ></app-control-button-submit>
          </form>
        }
        <app-alert-confirmation
          [parentComponent]="this"
          [message]="'AUTH_LOGIN_LINK_FORGOT_PASSWORD_SENT'"
          [optionalText]="'AUTH_LOGIN_LINK_FORGOT_PASSWORD_SENT_PROBLEM'"
        ></app-alert-confirmation>
      </c-card-body>
    </c-card>
  </div>
</div>
